import TemporaryActivationCode from "./TemporaryActivationCode";
import React, { useState, useEffect } from "react";
import "./Popup.css"; 

const Popup = () => {

  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 1200);

  useEffect(() => {
    // Function to handle window resize
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openLinkInNewTab = () => {
    window.open("https://signaltuner.com/update/counter.php", "_blank");
  };

  const openAppropriateLink = () => {
    const userAgent = window.navigator.userAgent;
    let link;

    if (userAgent.indexOf("Win") !== -1) {
      link = "https://signaltuner.com/Launch.html";
    } else if (userAgent.indexOf("Mac") !== -1) {
      link = "https://signaltuner.com/Launchmacos.html";
    } else {
      // Default link for other operating systems or in case detection fails
      link = "https://signaltuner.com/Launch.html";
    }

    window.open(link, "_blank");
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-columns">
        <div className="popup-left-column">
            {isMobileView ? (
              // Content for mobile view
              <>
                <h2 className="popup-text">SignalTuner could not connect with your desktop application.</h2>
                <p className="popup-text">SignalTuner cannot monitor mobile devices.</p>
                <p className="popup-text">Download and activate the SignalTuner app on your desktop device to monitor your signal health.</p>
              </>
            ) : (
              // Content for desktop view
              <>
                <h2 className="popup-text">SignalTuner could not connect with your desktop application.</h2>
                <p className="popup-text">- Download the SignalTuner desktop installer. </p>
                <button onClick={openLinkInNewTab} className="popup-button">
                  Download
                </button>
                <p className="popup-text">- Launch the SignalTuner desktop app, once you have it installed. </p>
                <button onClick={openAppropriateLink} className="popup-button">
                  Launch
                </button>
                <p className="popup-text">
                  - Activate with this code on the app's 'Welcome' page or in the 'Settings' to synchronize your device data with signaltuner.com
                </p>
                <TemporaryActivationCode />
              </>
            )}
          </div>
          <div className="popup-right-column">
            <img className="popup-image" src="https://www.signaltuner.com/images/onboarding-dashboard-desktop-client-image.png" alt="Desktop Client Setup" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
